module.exports = __webpack_public_path__ + "img/index23.d46b3482.png";